import React, { useContext } from 'react';

interface ListContextProps {
  sidePadding?: number | string;
}

export const ListContext = React.createContext<ListContextProps>({
  sidePadding: undefined,
});

export function useListContext(): ListContextProps {
  const context = useContext(ListContext);
  if (context) {
    return context;
  }
  throw new Error('List context can only be used within List component.');
}
